import DetailNavTitle from '@/components/business/detail-nav-title';
import {goBack} from '@/utils';
import React from 'react';
import {useTranslation} from 'react-i18next';
import InvitationIntro from '../invitation/home/invitation-intro';

const AgentRules = () => {
  const {t} = useTranslation();
  return (
    <div className="flex flex-col w-[23.4375rem] h-full fixed top-0 left-1/2 -translate-x-1/2 bg-bg">
      <DetailNavTitle
        title={t('label.agent-rule')}
        onBack={() => goBack()}
        hideServer
        hideAmount
      />
      <div className="flex flex-col flex-1 overflow-auto">
        <InvitationIntro />
      </div>
    </div>
  );
};

export default AgentRules;
